import React from "react";
import { Dialog, DialogTitle, DialogContent, Stack, Tooltip, IconButton } from "@mui/material";
import { PieceSymbol } from "chess.js";
import { PromotionMove } from "./types";

import queenImg from "../images/wQ.svg";
import rookImg from "../images/wR.svg";
import bishopImg from "../images/wB.svg";
import knightImg from "../images/wN.svg";

interface PromotionDialogProps {
  promotionMove: PromotionMove | null;
  onPromotionSelect: (piece: PieceSymbol) => void;
  onClose: () => void;
}

export const PromotionDialog: React.FC<PromotionDialogProps> = ({
  promotionMove,
  onPromotionSelect,
  onClose,
}) => {
  return (
    <Dialog
      open={Boolean(promotionMove)}
      onClose={onClose}
      maxWidth="xs"
      PaperProps={{
        sx: {
          backgroundColor: "#1e293b",
          color: "white",
          textAlign: "center",
          p: 1,
          borderRadius: 3,
        },
      }}
    >
      <DialogTitle sx={{ pb: 1, fontSize: "1.1rem", fontWeight: "bold" }}>
        Promote Pawn
      </DialogTitle>
      <DialogContent>
        <Stack direction="row" spacing={2} justifyContent="center" py={1}>
          {[
            { type: "q" as PieceSymbol, img: queenImg, label: "Queen" },
            { type: "r" as PieceSymbol, img: rookImg, label: "Rook" },
            { type: "b" as PieceSymbol, img: bishopImg, label: "Bishop" },
            { type: "n" as PieceSymbol, img: knightImg, label: "Knight" },
          ].map(({ type, img, label }) => (
            <Tooltip key={type} title={label}>
              <IconButton
                onClick={() => onPromotionSelect(type)}
                sx={{
                  width: 56,
                  height: 56,
                  bgcolor: "rgba(255,255,255,0.08)",
                  border: "1px solid rgba(255,255,255,0.15)",
                  "&:hover": {
                    bgcolor: "rgba(255,255,255,0.2)",
                    transform: "scale(1.1)",
                  },
                }}
              >
                <img src={img} alt={label} style={{ width: 38, height: 38 }} />
              </IconButton>
            </Tooltip>
          ))}
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default PromotionDialog;
